/* eslint-disable react/display-name */
// * You should NOT edit this file directly. Read CONTRIBUTING.md for more information on creating icons
import { __assign } from "tslib";
import React from 'react';
import { forwardRef } from '../../helpers/forwardRef';
import { BaseIcon } from '../../internal/BaseIcon';
export var ClothesAccsNecktieIcon20Solid = forwardRef('ClothesAccsNecktieIcon20Solid', function (props, ref) {
    return (React.createElement(BaseIcon, __assign({ ref: ref, viewBoxSize: 20 }, props),
        React.createElement("path", { d: "M6.565 1c-.727 0-1.383.658-1.2 1.471.443 1.972 1.719 3.39 2.357 4.002l-2.55 7.07a2 2 0 0 0 .394 2.014l2.946 3.282a2 2 0 0 0 2.976 0l2.946-3.282a2 2 0 0 0 .393-2.014l-2.549-7.068c.644-.612 1.931-2.034 2.363-4.012C14.818 1.652 14.163 1 13.44 1H6.565Z" })));
});
